import * as React from 'react';

import { PaginationProvider, SelectedRowsProvider } from 'common/contexts';

import EventProcedureLibrary from './EventProcedureLibrary';

type Props = {
  onClose: () => void;
  onAdd: (selectedProcedure: string) => void;
};

function EventProcedureLibraryForm({ onClose, onAdd }: Props) {
  return (
    <SelectedRowsProvider>
      <PaginationProvider>
        <EventProcedureLibrary onClose={onClose} onAdd={onAdd} />
      </PaginationProvider>
    </SelectedRowsProvider>
  );
}

export default EventProcedureLibraryForm;
